export const filterInitialForm = {
  buildingName: '',
  region: [],
  businessArea: [],
  state: [],
  city: [],
  status: '',
}